/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Upraviť",
  "i18n.actionBar.removeImage": "Odstranit",
  "i18n.actionBar.swapImage": "Vymeniť",
  "i18n.additionalInfoItemLayers.smartSorted.new": "Nové!",
  "i18n.additionalProducts.addToCart": "Pridať k objednávke",
  "i18n.additionalProducts.frame.description": "Odolný Hliníkový rámik: Matný strieborný odtieň, kvalitné sklo, bez lepidla – nie je potrebné ",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tip:",
  "i18n.additionalProducts.frame.subtitle": "Zložené puzzle je krásnou pamiatkou – v našom <b>rámiku</b> skvele vynikne.",
  "i18n.additionalProducts.frame2023.description": "Odolný Skladací rámik z kvalitného drevovláknitového materiálu – jednoduchá montáž, bez skla, vrátane Lepidla na puzzle",
  "i18n.additionalProducts.framePlastic.description": "Odolný hliníkový rámik: Matný strieborný odtieň, ochranné umelé sklo s antireflexnou vrstvou, bez lepidla - nie je potrebne",
  "i18n.additionalProducts.glue.description": "Stačí až na dve puzzle 1000 dielikov, vrátane nanášacej hubky",
  "i18n.additionalProducts.glue.hook": "Z vašich puzzle sa stane obrázok.\nTrvalo zlepi a chráni puzzle.",
  "i18n.additionalProducts.roll.description": "Vhodná pre puzzle 48 – 2000 dielikov",
  "i18n.additionalProducts.roll.hook": "Nemáte voľný stôl? Žiaden problém.\nPuzzle zrolujte, odložte do skrine a pokračujte neskôr.",
  "i18n.adventCalendarOverlay.activate": "Zobraziť náhľad 24 okienok",
  "i18n.adventCalendarOverlay.deactivate": "Vypnúť náhľad 24 okienok",
  "i18n.adventCalendarOverlay.notice": "(Čísla a čiary sa nevytlačia)",
  "i18n.button.addToCart": "Vložiť do nákupného košíka",
  "i18n.button.apply": "Pokračovať",
  "i18n.button.back": "Späť",
  "i18n.button.cancel": "Storno",
  "i18n.button.cancelAndFix": "zmeniť teraz",
  "i18n.button.chooseSmartSorted": "SMART SORTED",
  "i18n.button.close": "Zatvoriť",
  "i18n.button.continue": "Pokračovať",
  "i18n.button.createNewTextPlaceholders": "Zadať text ",
  "i18n.button.ignore": "Ignorovať",
  "i18n.button.ignoreAndContinue": "Pokračovať",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Bez SMART SORTED",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Fotografie",
  "i18n.button.retry": "Opakovať",
  "i18n.button.uploadPhotos": "Nahrať fotku(y)",
  "i18n.button.withSmartSorted": "SMART SORTED",
  "i18n.button.withoutSmartSorted": "Bez SMART SORTED",
  "i18n.control.colorChooser.color": "Farba",
  "i18n.control.fontChooser.placeholderText": "Písmo",
  "i18n.control.imageQuality.checkImages": "Skontrolujte kvalitu fotky",
  "i18n.control.imageQuality.imageSuitability": "Kvalita fotky:",
  "i18n.control.imageQuality.indicatorAltText": "Kvalita fotky",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Vyberte layout",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pre lepšiu čitateľnosť upravte, prosím, dĺžku textu",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Vybraný štýl písma je pre tento text moc dlhý.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maximálna veľkosť písma pre tento štýl bola prekročená.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Minimálna veľkosť písma pre tento štýl bola dosiahnutá.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Prosím vložte zalomenia textu",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Pokračujte v písaní na ďalší riadek alebo zväčšite textové pole.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Skontrolujte zadaný text. Toto písmo nepodporuje všetky znaky.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Bol dosiahnutý maximálny počet znakov",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pre lepšiu čitateľnosť upravte dĺžku textu.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "prosím zväčšite textové pole",
  "i18n.dialog.deletePlaceholder.message": "Tento krok sa nedá urobiť spätne",
  "i18n.dialog.deletePlaceholder.title": "Naozaj zmazať?",
  "i18n.dialog.error.title": [
    "Vyskytla se chyba",
    "Vyskytli sa chyby",
    "Vyskytli sa chyby"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Rozlíšenie tejto fotografie je príliš nízke na to, aby sa fotografia vytlačila ostrá a detailná!",
  "i18n.dialog.smartSorted.message": "So SMART SORTED môžete inovatívne a bez námahy zostaviť 1000-dielne motívy aj bez predlohy",
  "i18n.dialog.smartSorted.title": "Úspech puzzle zaručený",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Pre zmenu textu kliknite na \"{{text}}\".",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Text na škatuľke nebol zmenený",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Pokračovať bez textu",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Fotografiu vložíte kliknutím na symbol obrázku",
    "Fotografie vložíte kliknutím na symboly obrázku",
    "Fotografie vložíte kliknutím na symboly obrázku"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Nebola vložená jedna fotografie",
    "Nebolo vložené viac fotografií",
    "Nebolo vložené viac fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Zostáva nahrať jednu fotografiu.",
    "Zostáva nahrať viac fotografií.",
    "Zostáva nahrať viac fotografií."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Pre zmenu koláže kliknite prosím na kolónku s textom a obrázkom",
    "Pre zmenu koláže kliknite prosím na kolónku s textom a obrázkom",
    "Pre zmenu koláže kliknite prosím na kolónku s textom a obrázkom"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Nebolo vložené viac fotografií",
    "Nebolo vložené viac fotografií",
    "Nebolo vložené viac fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Pre zmenu textu kliknite prosím na kolónku s textom",
    "Pre zmenu textov kliknite prosím na kolónky s textom",
    "Pre zmenu textov kliknite prosím na kolónky s textom"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Kolónka s textom nebola zmenená",
    "Kolónky s textami neboli zmenené",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Nebolo nahrané viac fotografií",
  "i18n.error.additionalInfoItemsError.message": "Chyba pri načítavaní informačnej vrstvy",
  "i18n.error.additionalInfoItemsError.title": "Chyba pri načítavaní",
  "i18n.error.deprecatedBrowserError.message": "Prehliadač, ktorý používate, už nie je podporovaný. Aktualizujte ho, prosím, na novšiu verziu.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Na návrhu ste dlho nepracovali, takže nemôže byť dokončený. Začnite prosím od začiatku.",
  "i18n.error.designerExpiredError.title": "Návrh bol dokončený. ",
  "i18n.error.fontLoadingError.message": "Písmo sa nedá načítať",
  "i18n.error.fontLoadingError.title": "Chyba pri načítavaní",
  "i18n.error.imageLoadingError.message": "Fotka nebola nahraná. Bola odstránená z galérie a plochy",
  "i18n.error.imageLoadingError.title": "Chyba nahrávania",
  "i18n.error.imageProvisionError.message": "Jedna alebo viac fotiek neboli nahrané, zrejme sú v nepodporovanom formáte.",
  "i18n.error.imageProvisionError.title": "Fotka nemohla byť spracovaná.",
  "i18n.error.imageSelectionError.message": "Súbor \"{{reference1}}\" nemohl byť spracovaný.",
  "i18n.error.imageSelectionError.title": "Chyba nahrávania fotky",
  "i18n.error.imageSizeLimitExceededError.message": "Nahraný obrázok je príliš veľký.\nZmenšite ho prosím na menej ako 180 megapixelov a skúste ho nahrať znova.",
  "i18n.error.imageSizeLimitExceededError.title": "Chyba nahrávania fotky",
  "i18n.error.imageUploadError.message": "Vyskytol sa problém s internetovým pripojením. Skúste to znova neskôr.",
  "i18n.error.imageUploadError.title": "Chyba nahrávania fotky",
  "i18n.error.inlineSVGLoadingError.message": "Chyba načítania stránky pri vytváraní produktu \"{{reference1}}\" ",
  "i18n.error.inlineSVGLoadingError.title": "Chyba nahrávania",
  "i18n.error.invalidCharConfigError.message": "Tento typ písma nemožno použiť, vyberte prosím iný",
  "i18n.error.invalidCharConfigError.title": "Typ pisma nie je použiteľné",
  "i18n.error.malformedProductError.message": "Jeden alebo viac produktov neboli načítané. Je možné, že výrobok už nie je k dispozícii alebo vytváranie trvalo veľmi dlho. Je nám to veľmi ľúto. Začnite, prosím, nové vytváranie produktu.",
  "i18n.error.malformedProductError.title": "Chyba nahrávania",
  "i18n.error.notInStockError.message": "Vami vybraný výrobok nie je momentálne k dispozícii.\nKliknutím na naše logo vľavo hore prejdete na domovskú stránku, kde si môžete vybrať iný výrobok.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Zrejme došlo k prerušeniu internetového pripojenia. Na vytváranie produktu sa môžete vrátiť hneď ako dôjde k obnoveniu pripojenia.",
  "i18n.error.templateLoadingError.message": "Šablóna \"{{ error.reference[0] }}\" nebola nahraná.\nSkúste to znova neskôr.",
  "i18n.error.templateLoadingError.title": "Chyba nahrávania",
  "i18n.error.transformationError.message": "Zmenu nemožno vykonať",
  "i18n.error.transformationError.title": "Vyskytla sa chyba",
  "i18n.error.traudlLoadingError.message": "Skúste to prosím znova alebo vyberte inú fotku.",
  "i18n.error.traudlLoadingError.title": "Filter AI sa nepodarilo použiť. ",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" je v nepodporovanom formáte.",
  "i18n.error.unsupportedMediaTypeError.title": "Chyba počas nahrávania fotografií",
  "i18n.error.uploadProductError.message": "Jeden alebo niekoľko produktov nebolo prenesené na server.\nProsím skúste to znova neskôr.",
  "i18n.error.uploadProductError.title": "Chyba prenosu",
  "i18n.error.zoomModeError.message": "Váš text z predchádzajúceho návrhu nie je možné prevziať. Zadajte prosím nový text.",
  "i18n.error.zoomModeError.title": "Text nebol prijatý",
  "i18n.gallery.uploadPhotos.info": "Prosím kliknite na \"Nahrať fotku(y)\"",
  "i18n.gallery.uploadProgress": [
    "Nahrávanie fotky ...",
    "Nahrané fotky: {{current}} zo {{total}}",
    "Nahrané fotky: {{current}} zo {{total}}"
  ],
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Ušetríte",
  "i18n.price.total": "Celková cena",
  "i18n.priceDisplay.times": [
    "{{value}} kus každý za {{pricePerUnit}}",
    "{{value}} kusy každý za {{pricePerUnit}}",
    "{{value}} kusov každý za {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Príslušenstvo (voliteľné)",
  "i18n.progressOverlay.message.lines.one": "Ďakujeme za vytvorenie tohto pekného výrobku.",
  "i18n.progressOverlay.message.lines.two": "Všetko pre Vás pripravíme...",
  "i18n.template.insertText": "Zde zadajte text",
  "i18n.toolbox.gallery.title": "Vybrať fotky",
  "i18n.toolbox.image.title": "Upraviť fotku",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 fotka",
    "{{value}} fotky",
    "{{value}} fotiek"
  ],
  "i18n.toolbox.layout.title": "Zmena rozvrhnutie",
  "i18n.toolbox.layout.triggerText": "Rozvrhnutie",
  "i18n.toolbox.preview.title": "3D náhľad",
  "i18n.toolbox.productChooser.title": "Zmena produktu",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Upraviť text"
};


export class LocaleSkSK {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
